__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/2c0e5d404c19f266e31c9ee2f7223c7a1120964ba73b5498159d8ce8/";